import { fetch } from "src/services/apollo-fetch";
import { Query, Mutation } from "../_api";

export default {
    async addDeliveryRequest({ dispatch }, data) {
        const response = await fetch.mutate(
            {
                mutation: Mutation.addDeliveryRequest,
                variables: {
                    input: data,
                },
            },
            { showToast: false },
        );
        const newDelivery = response.data.addDeliveryRequest;
        dispatch("deliveryRequest/cancelDeliveryRequest", null, { root: true });
        return newDelivery;
    },
    async getPastDueInvoiceInfo() {
        const response = await fetch.query({
            query: Query.pastDueInvoiceInfo,
        });
        return response.data.pastDueInvoiceInfo;
    },
};
